// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swap-btn[data-v-e3f4e57e]{height:auto;width:auto;padding:4px}.address[data-v-e3f4e57e]{word-break:break-all;font-size:14px}.converted-amt[data-v-e3f4e57e]{margin-top:-13px}.amount-input[data-v-e3f4e57e]{width:100%}.currency-container[data-v-e3f4e57e]{margin-top:3px;margin-right:5px}", ""]);
// Exports
module.exports = exports;
